import React from 'react';
import Section from './Section';
import { Mail, Linkedin, Github } from 'lucide-react';

export default function Contact() {
    return (
        <footer className="bg-charcoal text-warm-white py-20">
            <Section id="contact" className="py-0">
                <div className="text-center space-y-8">
                    <h2 className="text-3xl font-serif font-bold text-warm-white mb-6">Let's Connect</h2>
                    <p className="text-warm-white/60 max-w-xl mx-auto mb-12">
                        I'm currently looking for new opportunities. Whether you have a question or just want to say hi, I'll try my best to get back to you!
                    </p>

                    <div className="flex justify-center gap-8 mb-16">
                        <a href="mailto:sriram.lankireddy@gmail.com" className="hover:text-earth-brown transition-colors">
                            <Mail size={24} />
                        </a>
                        <a href="https://www.linkedin.com/in/sriram-lankireddy" target="_blank" rel="noopener noreferrer" className="hover:text-earth-brown transition-colors">
                            <Linkedin size={24} />
                        </a>
                        <a href="https://github.com/sriram9573" target="_blank" rel="noopener noreferrer" className="hover:text-earth-brown transition-colors">
                            <Github size={24} />
                        </a>
                    </div>

                    <div className="border-t border-white/10 pt-8 text-sm text-warm-white/40">
                        <p>© 2025 Sri Ram Reddy Lankireddy. Crafted with React & Tailwind.</p>
                    </div>
                </div>
            </Section>
        </footer>
    );
}
